import { Pie } from 'vue-chartjs'

export default {
  extends: Pie,
  props: ['chartdata'],
  mounted () {
    this.renderChart(this.chartdata, {
      responsive: false,
      maintainAspectRatio: true,
      legend: {
        display: false
      },
      animation: false,
      tooltips: {
        callbacks: {
          label: (tooltipItem, data) => {
            let dataset = data.datasets[tooltipItem.datasetIndex]
            let label = data.labels[tooltipItem.index]
            let total = dataset.data.reduce((previousValue, currentValue, currentIndex, array) => {
              return previousValue + currentValue
            })

            let currentValue = dataset.data[tooltipItem.index]
            let percentage = Math.floor(((currentValue / total) * 100) + 0.5)

            return ` ${label}: ${currentValue} (${percentage}%)`
          }
        }
      },
      legendCallback: (chart) => {
        let legendHtml = []
        legendHtml.push('<ul class="chart-legend">')

        let data = chart.data
        let datasets = data.datasets
        let labels = data.labels

        if (datasets.length) {
          for (let i = 0; i < datasets[0].data.length; i++) {
            legendHtml.push('<li><span class="legend-circle" style="background-color:' + datasets[0].backgroundColor[i] + '"></span>')
            if (labels[i]) {
              let total = datasets[0].data.reduce((previousValue, currentValue, currentIndex, array) => {
                return previousValue + currentValue
              })
              let currentValue = datasets[0].data[i]
              let percentage = Math.floor(((currentValue / total) * 100) + 0.5)
              legendHtml.push(' <span class="legend-label">' + labels[i] + '</span> <div class="legend-data"><span class="legend-total">' + datasets[0].data[i] + '</span> <span class="legend-percentage">' + percentage + '%</span></div>')
            }
            legendHtml.push('</li>')
          }
        }

        legendHtml.push('</ul>')

        return legendHtml.join('')
      }
    })

    const HTML = this.$data._chart.generateLegend()
    this.$emit('generated', HTML)
  }
}



// WEBPACK FOOTER //
// ./src/components/Relatorios/Charts/Pie.js